/* eslint-disable import/no-webpack-loader-syntax */ import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import hexagonUrl from '../../../assets/gems/hexagon.svg?inline';
export function Hexagon({ ...props }) {
    return /*#__PURE__*/ _jsx("img", {
        ...props,
        src: hexagonUrl,
        alt: "HexagonImage"
    });
}
